import { styled } from '@mui/material';
import { Typography } from '@mui/material';

export const QuizStepHeading = styled(Typography)(({ theme }) => ({
  fontSize: '1.25rem',
  lineHeight: 1.25,
  fontWeight: 700,
  color: '#0f172a',
  [theme.breakpoints.up('sm')]: {
    fontSize: '32px',
  },
}));
